module.exports = __webpack_public_path__ + "assets/img/wh5_p10.b99c7d10.png";